var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.533 7.883c1.56-2.2 3.116-4.047 4.828-5.505C21.163-.003 25.02-.87 26.945 1.055c1.925 1.925 1.057 5.781-1.319 8.588-1.454 1.716-3.304 3.27-5.505 4.828.224 1.56.557 7.38-6.366 9.379 2.227-4.372 2.192-6.32 2.166-6.627a218.29 218.29 0 01-2.976 1.81l-3.98-3.98a258.748 258.748 0 011.811-2.975c-.303-.022-2.251-.058-6.627 2.166 2.015-6.92 7.824-6.585 9.384-6.36zm7.228-.644a2.334 2.334 0 10.005-3.309 2.334 2.334 0 00.002 3.303l-.007.006zM6.696 24.433c2.716.112 4.99-2.424 5.837-4.922l-4.1-4.1s-2.94.117-5.301 3.201c0 0 1.758-.708 3.301-.28-1.476 2.394-2.92 3.64-6.433 4.955 3.923.8 6.236.293 8.828-1.84 0 0-.394 1.313-2.132 2.986z",
    fill: "#2D3AAA",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.bb31b45d.svg";
export { ForwardRef as ReactComponent };